export class TourDisabledModus {
  id: number;
  tourId: number;
  modusId: number;
}
